import { postAuthGetSocialProviders } from '@repo/api-portal-sdk/gen'
import type { QueryFunctionContext } from '@tanstack/react-query'
import { z } from 'zod'
import { makeQueryKeys } from '@/lib/query-keys'
import { isSafePortalRedirect } from '@/lib/safe-redirect'

export const authSearchSchema = z.object({
	redirect: z
		.string()
		.refine(isSafePortalRedirect)
		.optional()
		.catch(undefined),
	error: z.string().optional()
})

export function socialProvidersQueryOptions() {
	return {
		queryKey: makeQueryKeys.auth.socialProviders(),
		queryFn: async ({ signal }: Pick<QueryFunctionContext, 'signal'>) => {
			const response = await postAuthGetSocialProviders({
				signal,
				throwOnError: false
			})
			return response.data?.data ?? []
		}
	}
}
